import Axios from "axios";

export default {

  /**
   * 列表
   * @param {*} keyword 
   * @param {*} page 
   */
  listPage(
    keyword,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/user/page`, {
      params: {
        keyword,
        page
      }
    });
  },

  /**
   * 项目员工详情
   * @param {*} userId 
   */
  staffInfo(
    userId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/user/${userId}`);
  },

  /**
   * 轨迹列表
   * @param {*} userId 
   */
  log(
    userId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/user/${userId}/visit`);
  },

  /**
   * 轨迹列表
   * @param {*} userId
   */
  logList(
    userId,
    day
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/user/${userId}/visit/day/${day}`);
  }

}